import React, { useEffect, useState } from "react";
import "./createChannelFirst.css";
import Form from "react-bootstrap/Form";
import CreateSuccessfulChannel from "../Create_successful/CreateSuccessfulChannel";
import axios from "../../../../axios";
import Select from "react-select";
// import { Popup } from "semantic-ui-react";
import AddMemebers from "./AddMemebers";
import Popup from "reactjs-popup";
import { Box, TextField } from "@mui/material";
// import "reactjs-popup/dist/index.css";

const CreateChannelFirst = ({ change, getPostCommunity }) => {
  const [channel, setChannel] = useState({
    addMembers: false,
  });
  const [openSuccessfull, setOpenSuccessfull] = useState(false);

  const [communityDetails, setCommunityDetails] = useState({
    name: null,
    description: null,
    profilePicture: null,
    isValid: true,
  });

  const [
    selectedStudentListClassStateParent,
    setSelectedListStudentClassStateParent,
  ] = useState([]);
  const [stdParent, setStdParent] = useState([]);
  const [secParent, setSecParent] = useState([]);
  const [successMsg, setSuccessMsg] = useState("");

  const { profilePicture, name, description, isValid } = communityDetails;
  useEffect(() => {
    if (name && name !== "" && description && description !== "") {
      setCommunityDetails({ ...communityDetails, isValid: false });
    } else {
      setCommunityDetails({ ...communityDetails, isValid: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [description, name]);

  const validateFileType = (filePath) => {
    var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

    if (!allowedExtensions.exec(filePath.name)) {
      return false;
    }
    return true;
  };

  const handleAttachment = async (file) => {
    if (file) {
      try {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
        const maxSizeInMB = 10;
        const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

        if (!allowedTypes.includes(file[0].type)) {
          window.alert(`Only JPEG/PNG files are allowed.`);
          return;
        }

        if (file[0].size > maxSizeInBytes) {
          window.alert(
            `File size exceeds ${maxSizeInMB} MB for ${file[0].name}.`
          );
          return;
        }
        setCommunityDetails({
          ...communityDetails,
          profilePicture: file[0],
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      {!openSuccessfull ? (
        <div className="create_channel_transprant_body">
          <div className=" px-4 py-3 create_channel_container">
            <img
              src="/images/cross-circle3.svg"
              className="channel_crossArrow"
              alt=""
              onClick={(e) => change(false)}
            />

            <div className="mb-4 create_channel_header">Create Channel</div>
            {!channel.addMembers && (
              <form>
                <div className="photoUploadHeader">Photo Upload</div>
                <div className="uploadImg_container">
                  <img
                    src={`${
                      profilePicture
                        ? URL.createObjectURL(profilePicture)
                        : "/images/uploadBackgroundimg.png"
                    }`}
                    className="uploadImage"
                    alt="uploadimg"
                  />

                  {!profilePicture ? (
                    <>
                      <input
                        type="file"
                        id="attachFileIcon"
                        style={{ display: "none" }}
                        onChange={(e) =>
                          // setCommunityDetails({
                          //   ...communityDetails,
                          //   profilePicture: e.target.files[0],
                          // })
                          handleAttachment(e.target.files)
                        }
                      />
                      <label htmlFor="attachFileIcon">
                        <img
                          src="/images/CameraIcon.png"
                          className="cameraIcon"
                          alt="cameraIcon"
                        />
                      </label>
                    </>
                  ) : (
                    <Popup
                      trigger={
                        <img
                          src="/images/CameraIcon.png"
                          className="cameraIcon"
                          alt="cameraIcon"
                        />
                      }
                      position="bottom center"
                    >
                      <div className="container_threedot">
                        <input
                          type="file"
                          id="attachFile"
                          style={{ display: "none" }}
                          onChange={(e) =>
                            // setCommunityDetails({
                            //   ...communityDetails,
                            //   profilePicture: e.target.files[0],
                            // })
                            handleAttachment(e.target.files)
                          }
                        />
                        <label htmlFor="attachFile" className="w-100">
                          <div className="PopupThreedots">Edit</div>
                        </label>
                        <div
                          className="PopupThreedots"
                          onClick={(e) =>
                            setCommunityDetails({
                              ...communityDetails,
                              profilePicture: null,
                            })
                          }
                        >
                          Remove
                        </div>
                      </div>
                    </Popup>
                  )}
                </div>
                <Box mt={2}>
                  <TextField
                    fullWidth
                    size="small"
                    required
                    label="Channel Name"
                    placeholder="Enter channel name"
                    value={name}
                    onChange={(e) => {
                      const value = e.target.value;
                      const regex = /^([^\s][^"/|\\;\-+(){}%!?*&=`']*?)?$/;
                      if (regex.test(value)) {
                        setCommunityDetails({
                          ...communityDetails,
                          name: value,
                        });
                      }
                    }}
                    inputProps={{ maxLength: 50 }}
                  />
                </Box>

                <Box mt={2}>
                  <TextField
                    fullWidth
                    size="small"
                    required
                    multiline
                    rows={3}
                    label="Channel Description"
                    placeholder="Enter description"
                    value={description}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.trim() !== "" || value === "") {
                        setCommunityDetails({
                          ...communityDetails,
                          description: value,
                        });
                      }
                    }}
                    inputProps={{ maxLength: 250 }}
                  />
                </Box>

                <div className="mt-4 d-flex justify-content-end align-items-center create_btn_box ">
                  <button
                    type="submit"
                    disabled={isValid}
                    onClick={(e) =>
                      setChannel({
                        ...channel,
                        addMembers: true,
                      })
                    }
                    className={`btn btn-danger create_Btn ${
                      isValid && "not_allowed"
                    }`}
                  >
                    Next
                  </button>
                </div>
              </form>
            )}
            {channel.addMembers && (
              <AddMemebers
                communityDetails={communityDetails}
                setOpenSuccessfull={setOpenSuccessfull}
                setChannel={setChannel}
                selectedStudentListClassStateParent={
                  selectedStudentListClassStateParent
                }
                setSelectedListStudentClassStateParent={
                  setSelectedListStudentClassStateParent
                }
                stdParent={stdParent}
                setStdParent={setStdParent}
                secParent={secParent}
                setSecParent={setSecParent}
                setSuccessMsg={setSuccessMsg}
              />
            )}
          </div>
        </div>
      ) : (
        <CreateSuccessfulChannel
          successMsg={successMsg}
          setOpenSuccessfull={setOpenSuccessfull}
          change={change}
          getPostCommunity={getPostCommunity}
        />
      )}
    </>
  );
};

export default CreateChannelFirst;
